export const isMobileEpgPath = (): boolean => {
    const { appEPGUrl } = window.APP_SETTINGS;
    return appEPGUrl === window.location.href;
};
